import { render, staticRenderFns } from "./TpmAxisCoordinateDataAcdList.vue?vue&type=template&id=10d229c8&"
import script from "./TpmAxisCoordinateDataAcdList.vue?vue&type=script&lang=js&"
export * from "./TpmAxisCoordinateDataAcdList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports